var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file radio
 * @author (zhaomiaoyuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { classPrefix } from '../../common/util';

import './Radio.less';

/**
 * 参数说明
 * name            单选组合时必需
 * style           非必需，自定义样式
 * value           必需，通过比较value判断是否选中
 * children        非必需，radioGroup专用
 * disabled        非必需，不可操作
 * checked         非必需，当前是否选中，默认false未选中
 * skin            非必需，radio button样式替换，目前只有绿色按钮
 * formFlag        非必需，form专用
 * onChange        选项变化时的回调函数
 * classPrefix     非必需，类名前缀
 */

var Radio = function (_Component) {
    _inherits(Radio, _Component);

    function Radio() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Radio);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radio.__proto__ || Object.getPrototypeOf(Radio)).call.apply(_ref, [this].concat(args))), _this), _this.radioChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Radio, [{
        key: 'renderRadio',
        value: function renderRadio() {
            var _classnames;

            var _props = this.props,
                name = _props.name,
                value = _props.value,
                children = _props.children,
                disabled = _props.disabled,
                style = _props.style,
                classPrefix = _props.classPrefix;

            var radioStyle = classnames({
                'radio-btn': true
            });
            var tpl = React.createElement('input', {
                type: 'radio',
                style: { opacity: radioStyle !== 'blue-btn' ? '0' : '1' },
                name: name,
                value: value,
                disabled: disabled,
                checked: !!this.props.checked,
                onChange: this.radioChange
            });
            return React.createElement(
                'label',
                {
                    className: classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-radio', true), _defineProperty(_classnames, 'radio-disabled', disabled), _classnames)),
                    style: style
                },
                React.createElement(
                    'span',
                    { className: 'pos-relative' },
                    tpl,
                    React.createElement('span', { className: radioStyle + ' replace-btn' })
                ),
                React.createElement(
                    'span',
                    { className: children ? 'margin-style-text' : '' },
                    children
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames2;

            var _props2 = this.props,
                classPrefix = _props2.classPrefix,
                theme = _props2.theme,
                className = _props2.className;

            var containerClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-padding-5', true), _defineProperty(_classnames2, classPrefix + '-radio-display', !this.props.layout), _defineProperty(_classnames2, 'radio-block', true), _defineProperty(_classnames2, classPrefix + '-theme-blue', theme === 'blue'), _defineProperty(_classnames2, className, !!className), _classnames2));
            return React.createElement(
                'div',
                { className: containerClass },
                this.renderRadio()
            );
        }
    }]);

    return Radio;
}(Component);

export default Radio;


Radio.defaultProps = {
    skin: 'green',
    checked: false,
    classPrefix: classPrefix,
    theme: 'green'
};

Radio.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    formFlag: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node,
    skin: PropTypes.string,
    layout: PropTypes.bool,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    theme: PropTypes.oneOf(['green', 'blue'])
};